import { endpoints } from '@/api/endpoints.ts'
import { axiosAPI } from '@/api/repository/repository.ts'

class ParingTokenRepository {
  async getPairingToken (): Promise<string> {
    const response = await axiosAPI.get<{ token: string }>(`${endpoints.pairingToken}`)
    return response.data.token
  }
}

export const paringTokenRepository = new ParingTokenRepository()
